export default __webpack_public_path__ + "static/media/memetican_big.f91ae893.jpg";